import Avatar from "@mui/material/Avatar";
import { userProfile } from "../../libs/UserProfile";

export default function UserAvatar({ className }: { className?: string }) {
  const user = userProfile(localStorage);

  return <Avatar className={className} src={user.userAvatar()} />;
}
